// IE 2026 11 01 / ODOO-350449 (заказ Игоря: форма Стовпчики та Запас площею — T15)
// Форма «Запас — площею» («проба пера»): строка запаса рисуется сплошной площадью под кривой остатка по периодам. Рисуем ПО ЯЧЕЙКАМ — каждая ячейка-дата
// получает свой кусок площади: левый край — середина между прошлым периодом и текущим, центр — значение ячейки, правый край — середина с
// следующим периодом; соседние куски стыкуются в непрерывную кривую и переживают виртуализацию / прокрутку wijmo (ни одного общего слоя поверх грида).
// Высота ∝ остатку по шкале строки (max остатка строки по видимым датам меры), отрицательный остаток — 0 и красная линия; заливка — цвет зоны
// месяца (доминирующая зона спутника zone_val, иначе — по сигналу класса ячейки, иначе нейтральный). Чистые функции — tests/unit/cellArea.test.mjs
import { statusZones_zoneLayers, statusZones_colors } from '@/utils/cellViews/statusZones'   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p207 зони запасу в колах — палітра і межі як у графіка покриття форми комірки)

export const CELL_AREA_NEUTRAL = '#90a4ae'
export const CELL_AREA_NEG = '#e53935'
export const CELL_AREA_LIGHT_EDGE = '#9e9e9e'   // IE 2026 11 02 / ODOO-350449 (ревью webscm #125869): обводка светлой зоны (белый «Оптимум») — та же серая, что у свотча легенды
export const cellArea_isLight = (c) => /^(#(fff|ffffff)|white)$/i.test(String(c || '').trim())
export const CELL_AREA_OPACITY = 0.38
// сигнал класса ячейки → зона заливки (зон бэка ещё нет в ячейке)
const SIGNAL_ZONE = { uncovered: 'oos', 'over-max': 'max', excess: 'excess' }

const str = (v) => (v === null || v === undefined ? '' : String(v)).trim()
const num = (v) => { const n = Number(v); return Number.isFinite(n) ? n : 0 }
const isNum = (v) => v !== undefined && v !== null && v !== '' && Number.isFinite(Number(v))
const isObj = (o) => !!o && typeof o === 'object' && !Array.isArray(o)
const r1 = (x) => Math.round(x * 10) / 10

// классы ячейки / строки — массив или строка через пробел → массив
const classList = (list) => (Array.isArray(list) ? list : (typeof list === 'string' ? list.split(/\s+/) : []))

// IE 2026 11 01 / ODOO-350449 (заказ Игоря: форма Стовпчики та Запас площею — T15b)
// запасное правило без спутников бэка (dev02 -32: zone_val ещё нет — строки запаса рисовались числами): строка раскладки остатка —
// правило свёртки opening_balance / closing_balance (opts.dlScale — эффективный aggregateScale строки DL от грида, иначе _DLRow / строки),
// measure_type или мера строки / ячейки про остаток (stock, offset, inventory, on_hand, balance, запас, залишок, остаток), название строки начинается с «Запас» / «Залишок» / «Остаток» / «Stock»
const STOCK_AGG_RE = /^(opening_balance|closing_balance)$/i
const STOCK_MEASURE_RE = /stock|offset|inventory|on_?hand|balance|запас|залиш|остат/i
const STOCK_TITLE_RE = /^\s*(запас|залишок|остаток|stock|inventory)/i
export function cellArea_isStockLayoutRow(dataItem, measure, opts = {}) {
    if (!isObj(dataItem)) return false
    const dlr = isObj(dataItem._DLRow) ? dataItem._DLRow : {}
    const agg = str(opts && opts.dlScale) || str(dlr._aggregateScale) || str(dlr.aggregateScale) || str(dataItem._aggregateScale) || str(dataItem.aggregateScale)
    if (STOCK_AGG_RE.test(agg)) return true
    const m = dataItem.measure
    const mId = typeof m === 'string' ? m : str(m && m.id) || str(dataItem.measure_ && dataItem.measure_.id)
    for (const x of [dataItem.measure_type, dlr.measure_type, mId, measure]) if (STOCK_MEASURE_RE.test(str(x))) return true
    for (const x of [dlr.title, dataItem.title]) if (STOCK_TITLE_RE.test(str(x))) return true
    return false
}

// строка запаса: у ячеек-дат меры есть спутник zone_val; или класс зоны запаса (stock-*) у строки / ячеек меры; или признак строки _DLRow.stock / _DLRow.shape с area;
// иначе — запасное правило по строке раскладки (cellArea_isStockLayoutRow, opts.dlScale). dates — даты колонок меры (YYYY-MM-DD), measure — мера
export function cellArea_isStockRow(dataItem, measure, dates = [], opts = {}) {   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: форма Стовпчики та Запас площею — T15b): + opts
    if (!isObj(dataItem)) return false
    const dlr = isObj(dataItem._DLRow) ? dataItem._DLRow : null
    if (dlr && (dlr.stock === true || dlr.is_stock === true)) return true
    if (dlr && /(^|[\s,;|])area($|[\s,;|])/i.test(Array.isArray(dlr.shape) ? dlr.shape.join(',') : str(dlr.shape))) return true
    const ms = str(measure)
    const isStockCls = (c) => /^stock-/.test(str(c))
    if (dlr && classList(dlr.cssClasses).some(isStockCls)) return true
    for (const d of (Array.isArray(dates) ? dates : [])) {
        const cell = dataItem[d]
        if (isObj(cell) && isObj(cell.zone_val) && Object.values(cell.zone_val).some(z => isObj(z) && Object.prototype.hasOwnProperty.call(z, ms))) return true
        if (dlr && isObj(dlr.cells) && classList(dlr.cells[`${d}.${ms}`]?.cssClasses).some(isStockCls)) return true
    }
    return cellArea_isStockLayoutRow(dataItem, measure, opts)   // IE 2026 11 01 / ODOO-350449 (заказ Игоря: форма Стовпчики та Запас площею — T15b)
}

// значения строки по датам меры → [число | null]
export function cellArea_values(dataItem, measure, dates = []) {
    const ms = str(measure)
    return (Array.isArray(dates) ? dates : []).map(d => {
        const cell = isObj(dataItem) ? dataItem[d] : null
        const v = isObj(cell) ? cell[ms] : undefined
        return isNum(v) ? Number(v) : null
    })
}

// шкала строки: max положительного остатка (0 — нечего рисовать)
export function cellArea_rowMax(values) {
    let m = 0
    for (const v of (Array.isArray(values) ? values : [])) if (isNum(v) && Number(v) > m) m = Number(v)
    return m
}

// соседние даты в порядке колонок → { prev, next } (нет — '')
export function cellArea_neighbors(dates, date) {
    const arr = Array.isArray(dates) ? dates : []
    const i = arr.indexOf(date)
    if (i < 0) return { prev: '', next: '' }
    return { prev: i > 0 ? arr[i - 1] : '', next: i < arr.length - 1 ? arr[i + 1] : '' }
}

// цвет заливки ячейки: доминирующая зона zone_val (по значению меры), иначе — зона по сигналу (uncovered / over-max / excess), иначе нейтральный
export function cellArea_zoneColor(zoneVal, measure, signals = []) {
    const zl = statusZones_zoneLayers(zoneVal, measure, (x) => x)
    if (zl && zl.length) {
        let best = zl[0]
        for (const l of zl) if (num(l.value) > num(best.value)) best = l
        return best.color
    }
    for (const s of (Array.isArray(signals) ? signals : [])) {
        const z = SIGNAL_ZONE[str(s && s.kind)]
        if (z) return statusZones_colors()[z]   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p207 зони запасу в колах — палітра і межі як у графіка покриття форми комірки): активная палитра зон
    }
    return CELL_AREA_NEUTRAL
}

// кусок площади ячейки: { prev, value, next (числа или null), max (шкала строки), w, h (размер ячейки), color } →
// { path (замкнутая площадь), line (верхняя кривая), color, neg, w, h } | null (значения нет / шкалы нет / ячейки нет)
export function cellArea_segment({ prev = null, value, next = null, max, w, h, color } = {}) {
    const W = num(w), H = num(h), M = num(max)
    if (!isNum(value) || !(W > 0) || !(H > 0)) return null
    const v = Number(value)
    if (!(M > 0) && !(v < 0)) return null
    const hA = Math.max(1, H - 3)
    const y = (x) => r1(H - 1 - hA * (M > 0 ? Math.max(0, Math.min(1, x / M)) : 0))
    const edge = (n) => (isNum(n) ? (Number(n) + v) / 2 : v)
    const yl = y(edge(prev)), yc = y(v), yr = y(edge(next))
    const cx = r1(W / 2)
    const path = `M0 ${H} L0 ${yl} L${cx} ${yc} L${W} ${yr} L${W} ${H} Z`
    const line = `M0 ${yl} L${cx} ${yc} L${W} ${yr}`
    return { path, line, color: str(color) || CELL_AREA_NEUTRAL, neg: v < 0, w: W, h: H }
}

// IE 2026 11 02 / ODOO-350449 (заказ Игоря: p208 форма «Площа» — від запасу на початок періоду до запасу на кінець, стик між комірками)
// Значение ячейки строки запаса — запас на НАЧАЛО периода; запас на конец периода = запас на начало следующего периода (соседняя ячейка справа).
// Кусок площади ячейки — трапеция: левый край на уровне запаса на начало, правый — на уровне запаса на конец; у соседей общая граница
// на одном уровне (конец периода i = начало периода i+1), кривая непрерывна. Конца нет (последняя ячейка / пусто справа) — плоско.
// Флаг fe.ux.cellAreaOpenClose (дефолт ВКЛ; ВЫКЛ — прежняя форма cellArea_segment: середины с соседями и пик в центре)
export const CELL_AREA_OC_FLAG = 'fe.ux.cellAreaOpenClose'
export function cellArea_openCloseOn(setting) {   // чтение флага (нет читателя / ошибка — ВКЛ)
    try { return typeof setting === 'function' ? setting(CELL_AREA_OC_FLAG, true) !== false : true } catch (e) { return true }
}
// { open (запас на начало), close (запас на конец | null — плоско), max (шкала строки), w, h, color } → { path, line, color, neg, w, h, yOpen, yClose } | null
export function cellArea_segmentOC({ open, close = null, max, w, h, color } = {}) {
    const W = num(w), H = num(h), M = num(max)
    if (!isNum(open) || !(W > 0) || !(H > 0)) return null
    const vo = Number(open), vc = isNum(close) ? Number(close) : vo
    if (!(M > 0) && !(vo < 0) && !(vc < 0)) return null
    const hA = Math.max(1, H - 3)
    const y = (x) => r1(H - 1 - hA * (M > 0 ? Math.max(0, Math.min(1, x / M)) : 0))
    const yo = y(vo), yc = y(vc)
    const path = `M0 ${H} L0 ${yo} L${W} ${yc} L${W} ${H} Z`
    const line = `M0 ${yo} L${W} ${yc}`
    return { path, line, color: str(color) || CELL_AREA_NEUTRAL, neg: vo < 0 || vc < 0, w: W, h: H, yOpen: yo, yClose: yc }
}

// разметка SVG куска (inline в ячейке, поверх фона, под событиями мыши — pointer-events: none в CSS)
export function cellArea_svg(seg) {
    if (!seg) return ''
    const c = String(seg.color).replace(/[<>"'&]/g, '')
    // IE 2026 11 02 / ODOO-350449 (ревью webscm #125869): зона «Оптимум» белая (stockZones ok) — линия тем же цветом терялась на белой ячейке; светлая заливка — серая обводка, как свотч легенды (STOCK_ZONES.ok.edge)
    const stroke = seg.neg ? CELL_AREA_NEG : (cellArea_isLight(c) ? CELL_AREA_LIGHT_EDGE : c)
    return `<svg class="cell-area-svg" viewBox="0 0 ${seg.w} ${seg.h}" preserveAspectRatio="none" width="100%" height="100%">`
        + `<path d="${seg.path}" fill="${c}" fill-opacity="${CELL_AREA_OPACITY}"></path>`
        + `<path d="${seg.line}" fill="none" stroke="${stroke}" stroke-width="1.2" vector-effect="non-scaling-stroke"></path></svg>`
}
